import { alias } from '@ember/object/computed';
import ReturnItemization from '@square/dashboard-data/models/squareup/beemo/api/v2/models/return-itemization';
import Adjustment from '@square/dashboard-data/models/squareup/beemo/api/v2/models/adjustment';
import { ProtoBaseModel, attr, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  returnItemization: repeated(ReturnItemization),
  returnItemizations: alias('returnItemization'),
  returnLineItemType: attr(String),
  returnSurcharge: repeated(Adjustment),
  returnSurcharges: alias('returnSurcharge')
});